import { createSelector } from 'reselect';
import reduce from 'ramda/es/reduce';
import values from 'ramda/es/values';


export default createSelector(
  purchases => purchases,
  purchases => reduce((acc, { total }) => {
    const sum = acc + total;
    return sum;
  }, 0, values(purchases)),
);
